/* eslint-disable */
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { CONSTANTS } from './config.service';
import { DateTimeService } from './date-time/date-time.service';
import { LoggerService } from './logger.service';
import { PrefsService } from './prefs.service';
import { SqlHelperService } from './sql-helper.service';
import { SchemaService } from './survey/schema.service';
import { UtilsService } from './utils.service';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Injectable({
  providedIn: 'root'
})
export class SignupSurveyService {
  db;
  table = CONSTANTS.signupSurveyTableName;
  ID = 1;
  noUpdateFields = ['id', 'firstCompleted', 'lastCompleted', 'completedCount', 'queued', 'lap', 'maxLapIndex']; // HACK queued isn't a field on this survey type
  createTableSql =
    'CREATE TABLE IF NOT EXISTS ' +
    this.table +
    ' ( ' +
    'id INTEGER primary key autoincrement, ' +
    'firstStarted INTEGER, ' +
    'lastStarted INTEGER, ' +
    'firstCompleted INTEGER, ' +
    'lastCompleted INTEGER, ' +
    'completedCount INTEGER DEFAULT 0, ' +
    'sent INTEGER DEFAULT 0, ' + // bool, not queued like other survey types, sent directly
    'complete INTEGER DEFAULT 0, ' +
    'lastPage TEXT, ' +
    'callCenterAnswered INTEGER DEFAULT 0, ' +
    'path TEXT, ' +
    'futurePath TEXT, '; // beginning of SQL... ends within col list

  constructor(
    private logger: LoggerService,
    private utils: UtilsService,
    private sqlHelper: SqlHelperService,
    private schema: SchemaService,
    private dateTime: DateTimeService,
    private prefs: PrefsService,
    private auth: AuthService
  ) {
    this.logger.log('Signup survey constructor', MSRemoteLoggerCategory.SIGNUP_SURVEY_SERVICE);
  }

  //initialize function will take a survey name, and pass that here
  getCreateTableSql() {
    const dbColDefs = [];

    return this.schema.parse(CONSTANTS.surveyTypes.SIGNUP).then((fields: any[]) => {
      fields.forEach((field) => {
        const name = field[0];
        const type = field[1];
        dbColDefs.push(name + ' ' + type);
      });
      return this.createTableSql + dbColDefs.join(', ') + ');';
    });
  }

  update(survey) {
    const updateValues = Object.assign({}, survey);

    this.noUpdateFields.forEach((field) => {
      delete updateValues[field];
    });

    if (survey.complete === 1) {
      if (survey.firstCompleted === 0 || survey.firstCompleted === null) {
        updateValues.firstCompleted = this.dateTime.getNowSeconds();
      }
      updateValues.lastCompleted = this.dateTime.getNowSeconds();
      updateValues.completedCount_LITERAL = 'completedCount + 1';
    }

    return this.sqlHelper.getUpdatePromise(this.db, this.table, updateValues, { id: survey.id }).then(
      (updateCount) =>
        // TODO - pubsub
        //pubSub.publish(EVENTS.signupSurveyUpdated, survey.complete, survey.id);
        updateCount
    );
  }

  updateSurveyNav(survey) {
    // ignores other fields and just updates nav fields (for previous)
    const updateValues = this.utils.subset(survey, ['path', 'lastPage']);
    return this.sqlHelper.getUpdatePromise(this.db, this.table, updateValues, { id: survey.id });
  }

  get(id) {
    return this.sqlHelper
      .getSelectPromise(this.db, this.table, ['*'], { id: this.ID })
      .then((rows: any[]) => {
        if (rows.length) {
          return rows[0];
        } else {
          return this.sqlHelper
            .getInsertPromise(this.db, this.table, { id: this.ID, firstStarted: this.dateTime.getNowSeconds() })
            .then(() => this.sqlHelper.getSelectPromise(this.db, this.table, ['*'], { id: this.ID }))
            .then((rows) => rows[0]);
        }
      })
      .catch((err) => {});
  }

  markSent() {
    return this.sqlHelper.getUpdatePromise(this.db, this.table, { sent: 1 }, { id: this.ID });
  }

  updateWithSignupEmail(surveyData) {
    // if we have a signup email and the survey has an hhEmailsPrimary field, write it out
    return this.auth
      .getSignupEmail()
      .then((email) => {
        if (email !== null && surveyData.hasOwnProperty('hhEmailsPrimary')) {
          surveyData.hhEmailsPrimary = email;
          return this.update(surveyData);
        } else {
          return Promise.resolve();
        }
      })
      .catch(() => Promise.resolve());
  }

  // dropAll: function () {
  //     return sqlHelper.getRawSqlPromise(db, 'DROP TABLE IF EXISTS ' + table);
  // }

  initialize() {
    this.logger.log('Initializing signup survey.', MSRemoteLoggerCategory.SIGNUP_SURVEY_SERVICE);

    return this.sqlHelper
      .createDb({ name: CONSTANTS.mainFrontEndDbName, location: 'default', androidDatabaseProvider: 'system', androidLockWorkaround: 1 })
      .then((db) => {
        this.db = db;
        return this.getCreateTableSql();
      })
      .then((res) => this.sqlHelper.createTablePromise(this.db, res))
      .then(() => this.get(null))
      .then(
        (surveyData) => this.updateWithSignupEmail(surveyData) // when we initialize the signup survey, save the signup email (or address)
      )
      .then(() => {
        this.logger.makeSuccessLogger('Initialized signup survey');
      })
      .catch((err) => {
        this.logger.log('Error initializing signup survey provider', MSRemoteLoggerCategory.SIGNUP_SURVEY_SERVICE, err);
      });
  }
}
